import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {DateAgoModule} from '../../../../core/pipe/date-ago.module';
import {ModalModule} from '../../modal/modal.module';
import {RecipeOrderByComponent} from './recipe-order-by.component';
import {DropdownModule} from '../../../../core/directive/dropdown/dropdown.module';

@NgModule({
  declarations: [
    RecipeOrderByComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    DateAgoModule,
    ModalModule,
    ReactiveFormsModule,
    DropdownModule,
  ],
  exports: [
    RecipeOrderByComponent
  ],
  providers: [],
})
export class RecipeOrderByModule {
}
